(() => {
  if (window.blaspoUniversMenuBound) return;
  window.blaspoUniversMenuBound = true;
  document.addEventListener('click', (event) => {
    document.querySelectorAll('.bp-menu-all[open]').forEach((menu) => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.bp-menu-all[open]').forEach((menu) => {
      menu.open = false;
      menu.querySelector('summary')?.focus();
    });
  });
})();

